import {
  HouseStudyDayIndividual,
  HouseStudyDayIndividualDto,
} from '../../../../../../../lib/graphql'
import {
  divideByFactor,
  multiplyByFactor,
} from '../../../../../../../utils/prices'

const computeInputPrice = (value: undefined | null | string | number) => {
  return value === '' || value === null || value === undefined
    ? null
    : multiplyByFactor(value)
}

export const computeHouseStudyDayIndividualInputs = ({
  isEnabled,
  options,
}: HouseStudyDayIndividualDto): HouseStudyDayIndividualDto => {
  const computedInputs: HouseStudyDayIndividualDto = {
    isEnabled,
    options: {
      capacity: {
        max: Number(options.capacity.max),
        min: Number(options.capacity.min),
      },
      seasonalPrices: [
        {
          endAt: options.seasonalPrices[0].endAt,
          startAt: options.seasonalPrices[0].startAt,
          fullDay: {
            highPrice: computeInputPrice(
              options.seasonalPrices[0].fullDay.highPrice,
            ),
            lowPrice: computeInputPrice(
              options.seasonalPrices[0].fullDay.lowPrice,
            ),
            mediumPrice: computeInputPrice(
              options.seasonalPrices[0].fullDay.mediumPrice,
            ),
          },
          halfDay: {
            highPrice: computeInputPrice(
              options.seasonalPrices[0].halfDay.highPrice,
            ),
            lowPrice: computeInputPrice(
              options.seasonalPrices[0].halfDay.lowPrice,
            ),
            mediumPrice: computeInputPrice(
              options.seasonalPrices[0].halfDay.mediumPrice,
            ),
          },
          residential: {
            highPrice: computeInputPrice(
              options.seasonalPrices[0].residential.highPrice,
            ),
            lowPrice: computeInputPrice(
              options.seasonalPrices[0].residential.lowPrice,
            ),
            mediumPrice: computeInputPrice(
              options.seasonalPrices[0].residential.mediumPrice,
            ),
          },
        },
      ],
      vatRate: options.vatRate,
    },
  }

  return computedInputs
}

const computeDefaultValuePrice = (value: undefined | null | number) => {
  return value === null || value === undefined ? null : divideByFactor(value)
}

export const computeHouseStudyDayIndividualDefaultValues = ({
  isEnabled,
  options,
}: HouseStudyDayIndividual): HouseStudyDayIndividualDto => {
  const computedInputs: HouseStudyDayIndividualDto = {
    isEnabled,
    options: options
      ? {
          ...options,
          seasonalPrices: [
            {
              endAt: options.seasonalPrices[0].endAt,
              startAt: options.seasonalPrices[0].startAt,
              fullDay: {
                highPrice: computeDefaultValuePrice(
                  options.seasonalPrices[0].fullDay.highPrice,
                ),
                lowPrice: computeDefaultValuePrice(
                  options.seasonalPrices[0].fullDay.lowPrice,
                ),
                mediumPrice: computeDefaultValuePrice(
                  options.seasonalPrices[0].fullDay.mediumPrice,
                ),
              },
              halfDay: {
                highPrice: computeDefaultValuePrice(
                  options.seasonalPrices[0].halfDay.highPrice,
                ),
                lowPrice: computeDefaultValuePrice(
                  options.seasonalPrices[0].halfDay.lowPrice,
                ),
                mediumPrice: computeDefaultValuePrice(
                  options.seasonalPrices[0].halfDay.mediumPrice,
                ),
              },
              residential: {
                highPrice: computeDefaultValuePrice(
                  options.seasonalPrices[0].residential.highPrice,
                ),
                lowPrice: computeDefaultValuePrice(
                  options.seasonalPrices[0].residential.lowPrice,
                ),
                mediumPrice: computeDefaultValuePrice(
                  options.seasonalPrices[0].residential.mediumPrice,
                ),
              },
            },
          ],
        }
      : {
          capacity: { max: 0, min: 0 },
          seasonalPrices: [
            {
              endAt: null,
              startAt: null,
              fullDay: { highPrice: null, lowPrice: null, mediumPrice: null },
              halfDay: { highPrice: null, lowPrice: null, mediumPrice: null },
              residential: {
                highPrice: null,
                lowPrice: null,
                mediumPrice: null,
              },
            },
          ],
          vatRate: null,
        },
  }

  return computedInputs
}
